export default __webpack_public_path__ + "static/media/olavarria.ec171e3e.jpg";